



































































































import Component from "vue-class-component";
import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { updateGTMGlobalVariables } from "@/utils/gtm";

@Component
export default class EULA extends BaseRootPageComponent {
  created() {
    // updateGTMGlobalVariables(this);
  }
}
